import { getCmsBaseUrl, useCookie, useUmbracoPreviewModeState } from "#imports";

export function useUmbracoPreviewMode () {
  function isPreviewMode () {
    const previewCookie = useCookie( "UMB_PREVIEW" );
    const previewState = useUmbracoPreviewModeState();

    return !!previewCookie.value || previewState.value;
  }

  async function getPreviewModeApiKey () {
    try {
      return await $fetch( "/api/preview/authorize", {
        method: "GET",
        baseURL: getCmsBaseUrl(),
      } );
    } catch ( err ) {
      console.error( "Error loading preview mode api key", err );
    }
  }

  return {
    isPreviewMode,
    getPreviewModeApiKey,
  };
}
